import Control from "ol/control/Control";
import { useContext, useEffect, useState, useMemo, useRef } from "react";
import ReactDOM from "react-dom";
import MapContext from "../Map/MapContext";

function Container({
  children,
  meta,
  bottom,
}: {
  children?: any;
  meta?: boolean;
  bottom?: boolean;
}) {
  const detailsRef = useRef(null);

  return children ? (
    <Portal>
      <div
        ref={detailsRef}
        className={`card ol-details${meta ? " left" : ""}${
          bottom ? " bottom" : ""
        }`}
      >
        {children}
      </div>
    </Portal>
  ) : null;
}

export const Portal = ({
  children,
  className = "container-portal",
  el = "div",
}: {
  children: any;
  className?: string;
  el?: string;
}) => {
  const { map } = useContext(MapContext);
  const [container] = useState(() => {
    // This will be executed only on the initial render
    // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    return document.createElement(el);
  });

  const detailsView = useMemo(() => {
    if (container) {
      return new Control({
        element: container as any,
      });
    }
  }, [container]);

  useEffect(() => {
    if (detailsView) map?.addControl(detailsView);
    return () => {
      if (detailsView) map?.removeControl(detailsView);
    };
  }, [map, detailsView]);

  return ReactDOM.createPortal(children, container);
};

export default Container;
